import { ReactSession } from "../../../../lib/secure_reactsession";

export async function generateTestingToolReport(formData) {
  const token = ReactSession.get("token");
  const response = await fetch(
    `${process.env.REACT_APP_IMG_URL}api/v2/researcher/mythology/testing-tool-generate-summary`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      body: formData,
    }
  );

  const isJson = response.headers.get("content-type")?.includes("application/json");
  const data = isJson ? await response.json() : null;

  if (!response.ok) {
    const message =
      (data && (data.error || data.message)) ||
      "Failed to generate testing tool report";
    throw new Error(message);
  }

  const body = data?.data ?? data;
  if (body && data?.slug && !body.slug) {
    return { ...body, slug: data.slug };
  }
  return body;
}

export async function getTestingToolBySlug(slug) {
  const token = ReactSession.get("token");
  const response = await fetch(
    `${process.env.REACT_APP_IMG_URL}api/v2/researcher/mythology/testing-tool/${encodeURIComponent(slug)}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const isJson = response.headers.get("content-type")?.includes("application/json");
  const data = isJson ? await response.json() : null;

  if (!response.ok) {
    const message =
      (data && (data.error || data.message)) ||
      "Failed to load audit report";
    throw new Error(message);
  }

  const body = data?.data ?? data;
  if (body && data?.slug && !body.slug) {
    return { ...body, slug: data.slug };
  }
  return body;
}

export async function reAuditTestingToolReport(slug) {
  const token = ReactSession.get("token");
  const response = await fetch(
    `${process.env.REACT_APP_IMG_URL}api/v2/researcher/mythology/testing-tool/${encodeURIComponent(slug)}/re-audit`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const isJson = response.headers.get("content-type")?.includes("application/json");
  const data = isJson ? await response.json() : null;

  if (!response.ok) {
    const message =
      (data && (data.error || data.message)) ||
      "Failed to re-audit testing tool report";
    throw new Error(message);
  }

  const body = data?.data ?? data;
  if (body && data?.slug && !body.slug) {
    return { ...body, slug: data.slug };
  }
  return body;
}

export async function exportTestingToolReport(testTestingToolId) {
  const token = ReactSession.get("token");
  const response = await fetch(
    `${process.env.REACT_APP_IMG_URL}api/v2/researcher/mythology/testing-tool-export`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ test_testing_tool_id: testTestingToolId }),
    },
  );

  const isJson = response.headers.get("content-type")?.includes("application/json");
  const data = isJson ? await response.json() : null;

  if (!response.ok) {
    const message =
      (data && (data.error || data.message)) ||
      "Failed to export testing tool report";
    throw new Error(message);
  }

  return data;
}